import { render } from "./MMAssessmentViewAnswer.vue?vue&type=template&id=0a002d8c"
import script from "./MMAssessmentViewAnswer.vue?vue&type=script&lang=js"
export * from "./MMAssessmentViewAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__